export default "__VITE_ASSET__B88_IQrE__"